import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ReportMetadata, ReportCategory } from "../../models/report.model";
import { ReportingService } from "../../services";

@Component({
  selector: "app-reports-list",
  templateUrl: "./reports-list.component.html",
  styleUrls: ["./reports-list.component.scss"]
})
export class ReportsListComponent implements OnInit {
  reports: ReportMetadata[] = [];

  filteredReports: ReportMetadata[] = [];
  selectedCategory: ReportCategory = ReportCategory.All;
  categories: ReportCategory[] = [ReportCategory.All];

  constructor(private router: Router, private reportService: ReportingService) {}

  ngOnInit(): void {
    this.reportService.getAvailableReports().subscribe((reports) => {
      this.reports = reports;
      this.extractCategories();
      this.filterByCategory(this.selectedCategory);
    });
  }

  extractCategories(): void {
    const uniqueCategories = new Set(this.reports.map(r => r.category));
    this.categories = [ReportCategory.All, ...Array.from(uniqueCategories)];
  }

  filterByCategory(category: ReportCategory): void {
    this.selectedCategory = category;
    if (category === ReportCategory.All) {
      this.filteredReports = this.reports;
    } else {
      this.filteredReports = this.reports.filter(r => r.category === category);
    }
  }

  viewReport(reportId: string): void {
    this.router.navigate(["/reports", reportId]);
  }
}
